import { NgModule } from '@angular/core';
import {SectionCategoryComponent} from "./section-category.component";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {UnescapeCachePipeModule} from "../../shared/pipes/unescape-cache-pipe";

@NgModule({
  declarations: [SectionCategoryComponent],
  exports: [SectionCategoryComponent],
  imports: [CommonModule, RouterModule, UnescapeCachePipeModule],
  providers: []
})
export class SectionCategoryModule {

}



// WEBPACK FOOTER //
// ./src/app/category/section/section-category.module.ts